/* Copyright (c) 2017 Backpack Health LLC */
/* global window */

import { combineReducers } from 'redux';
import * as _ from 'lodash';

import actionNames from '../appAuthorized/redux/actionNames';
import apiDataReducer from '../appAuthorized/redux/apiDataReducer';
import userFlowsReducer from '../appAuthorized/redux/userFlowsReducer';
import systemNotificationReducer from './ducks/systemNotification';
import ownersReducer from './ducks/owners';
import notificationsReducer from './ducks/notifications';
import localeReducer from './ducks/locale';
import userReducer from './ducks/user';
import systemModalReducer from './ducks/systemModal';
import groupReducer from './ducks/group';
import sessionReducer from './ducks/session';
import actionItemsReducer from './ducks/actionItems';
import listsReducer from './ducks/lists/lists';
import policyReducer from './ducks/policy';
import medicalJewelryReducer from './ducks/medicalJewelry';
import consentReducer from './ducks/consent';
import integrationsReducer from './ducks/integrations';
import contactsReducer from './ducks/contacts';
import uiReducer from './ducks/ui';

export const AppTabNames = {
  MyBackpack: 'MyBackpack',
  Home: 'Home',
  Messages: 'Messages',
  Share: 'Share',
};

export const AppModalNames = {
  None: 'None',
  Account: 'Account',
  Settings: 'Settings',
  Search: 'Search',
  MyBackpack: 'MyBackpack',
  Messages: 'Messages',
  Share: 'Share',
};


function loadingPercentageReducer(state = {}, action) {
  switch (action.type) {
    case actionNames.setLoadingProgress:
      return _.assign({}, state, action.payload);
    default:
      return state;
  }
}

function activeProfileReducer(state = -1, action) {
  switch (action.type) {
    case actionNames.setActiveProfile:
      return action.payload.id;
    default:
      return state;
  }
}

function systemMessagesReducer(state = {}, action) {
  switch (action.type) {
    case actionNames.setSystemMessage:
      return _.assign({}, state, action.payload);
    default:
      return state;
  }
}

function contentEntryReducer(state = {
  leavingContentIsAnimated: false,
  enteringContentIsAnimated: false,
  enterTransition: '',
  exitTransition: '',
  enter: 'none',
  exit: '',
  transitionName: '',
  direction: '',
}, action) {
  switch (action.type) {
    case actionNames.setContentEntry:
      return _.assign({}, state, action.payload);
    default:
      return state;
  }
}

function pendingEditReducer(state = {
  healthEntry: {
    profileId: '-1',
    data: {},
  },
  data: {},
  hasChanges: false,
  validation: {},
}, action) {
  switch (action.type) {
    case actionNames.setPendingEdit:
      return _.assign({}, state, {
        hasChanges: true,
        data: action.payload.data,
        validation: action.payload.validation || { isValid: true, message: '' },
      });
    case actionNames.updatePendingEdit:
      return _.assign({}, state, {
        hasChanges: true,
        data: _.assign({}, state.data, action.payload.data),
        validation: action.payload.validation || { isValid: true, message: '' },
      });
    case actionNames.clearPendingEdit:
      return _.assign({}, state, {
        hasChanges: false,
        data: {},
        validation: {},
      });
    case actionNames.updatePendingHealthEntry:
      return _.assign({}, state, {
        healthEntry: {
          profileId: action.payload.profileId,
          data: action.payload.healthEntryData,
        },
      });
    case actionNames.clearPendingHealthEntry:
      return _.assign({}, state, {
        healthEntry: {
          profileId: '-1',
          data: {},
        },
      });
    default:
      return state;
  }
}

function navigationReducer(state = {
  pageHistory: [{ pathname: window.location.pathname, state: {} }],
}, action) {
  switch (action.type) {
    case actionNames.navigationGoTo:
      state.pageHistory.push(action.payload);
      return _.assign({}, {
        pageHistory: state.pageHistory,
      });
    case actionNames.navigationSetHistory:
      return _.assign({}, {
        pageHistory: action.payload,
      });
    default:
      return state;
  }
}

const rootReducer = combineReducers({
  data: apiDataReducer,
  userFlows: userFlowsReducer,

  navigation: navigationReducer,

  pendingEdit: pendingEditReducer,

  contentEntry: contentEntryReducer,

  activeProfileId: activeProfileReducer,
  user: userReducer,
  loadingPercentage: loadingPercentageReducer,
  groups: groupReducer,
  integrations: integrationsReducer,

  session: sessionReducer,
  actionItems: actionItemsReducer,

  systemMessages: systemMessagesReducer,
  systemNotification: systemNotificationReducer,
  systemModal: systemModalReducer,

  owners: ownersReducer,
  notifications: notificationsReducer,
  policy: policyReducer,
  medicalJewelry: medicalJewelryReducer,
  consent: consentReducer,

  locale: localeReducer,
  lists: listsReducer,

  contacts: contactsReducer,
  ui: uiReducer,
});

export default rootReducer;
